import _ from 'lodash'
import { parseUrl, stringify } from 'query-string'
import UAParser from 'ua-parser-js'
import axios from 'axios'

const DEEPLINK_READ_ERROR_MSG = 'deeplink.cvs 를 읽는중 에러가 발생 했습니다.'
export const DEVICE_TYPE_ANDROID = 'android'
export const DEVICE_TYPE_IOS = 'ios'
export const DEVICE_TYPE_MOBILE = 'mobile'
export const DEVICE_TYPE_PC = 'pc'
export const DEVICE_UNNECESSARY_PROCESS = 'none'

export const deepLinkChecker = deeplink => {
  if(!_.isArray(deeplink)) throw Error(DEEPLINK_READ_ERROR_MSG)
  if(deeplink.length === 0) throw Error('딥링크 정보가 없습니다. deeplink.length === 0')
  return deeplink
}

export const stringifyUrl = ({url, query = ''}) => {
  const hasQuery = Object.keys(query).length
  if(hasQuery) {
    return url + '?' + stringify(query)
  }else {
    return url
  }
}

export const isMobile = () => {
  const parser = new UAParser()
  const { type } = parser.getDevice()
  return type === 'mobile' || type === 'tablet'
}

export const isIOS = () => {
  const parser = new UAParser()
  const { name } = parser.getOS()
  return name.toUpperCase() === 'IOS'
}
export const isAndroid = () => {
  const parser = new UAParser()
  const { name } = parser.getOS()
  return name.toUpperCase() === 'ANDROID'
}
export const getDeviceType = () => {
  if(isIOS()) {
    return DEVICE_TYPE_IOS
  }else if(isAndroid()) {
    return DEVICE_TYPE_ANDROID
  }else {
    return DEVICE_UNNECESSARY_PROCESS
  }
}


export const getLinkList = deepLinkCsv => {
  const getMwebUrl = item => _.get(item, 'mweb', '')
  return deepLinkCsv.filter((item) => {
    const url = getMwebUrl(item)
    const use = _.get(item, 'use', '')
    return url !== null
      && url !== ''
      && use !== null
      && _.get(item, 'use', '').toLowerCase() === 'y'
  }).map(item => {
    const orgUrl = getMwebUrl(item)
    const {url, query} = parseUrl(orgUrl)
    const hasQuery = Object.keys(query).length > 0
    const hasPathValue = url.indexOf('{') > -1 && url.indexOf('}') > -1
    if (hasPathValue) {
      const pathParam = url.substring(url.indexOf('{') + 1, url.indexOf('}'))
      _.set(item, 'pathParam', pathParam)
      _.set(item, 'comparablePath', orgUrl.replace(`{${pathParam}}`, '{path}'))
    }
    if (hasQuery) {
      const keyObj = Object.keys(query).reduce((acc, curr) => {
        acc[curr] = ''
        return acc
      }, {})
      _.set(item, 'queryParam', keyObj)
    }
    return item
  })
}

export const openIosDeepLink = (deepLinkUrl) => {
  // let hidden, visibilityChange
  // if (typeof document.hidden !== 'undefined') { // Opera 12.10 and Firefox 18 and later support
  //   hidden = 'hidden'
  //   visibilityChange = 'visibilitychange'
  // } else if (typeof document.msHidden !== 'undefined') {
  //   hidden = 'msHidden'
  //   visibilityChange = 'msvisibilitychange'
  // } else if (typeof document.webkitHidden !== 'undefined') {
  //   hidden = 'webkitHidden'
  //   visibilityChange = 'webkitvisibilitychange'
  // }
  const openIosApp = () => {
    // document.addEventListener(visibilityChange, function () {
    //   if (document[hidden]) {
    //     if (window.appOpener) {
    //       clearTimeout(window.appOpener)
    //     }
    //   }
    // })
    location.href = deepLinkUrl
    // window.appOpener = setTimeout(function () {
    //   location.href = 'itms-apps://itunes.apple.com/kr/app/pug-pooq/id987782077?mt=8'
    // }, 3000)
  }
  openIosApp()
}

export const openAndroidDeepLink = (deepLinkUrl) => {
  try {
    location.href = deepLinkUrl
  }catch(e) {
    console.log(e);
  }
}

export const comparePath  = (orgPath, checkPath) => {
  let isCorrect = false
  if (orgPath === checkPath) return true
  const orgPathList = orgPath.split('/')
  const checkPathList = checkPath.split('/')
  if (orgPathList.length === checkPathList.length) {
    let isMatched = true
    let i = 0
    while (i < checkPathList.length) {
      if (!isMatched) break
      const orgPath = orgPathList[i]
      const checkPath = checkPathList[i]
      if (orgPath !== '{path}') {
        isMatched = orgPath === checkPath
      }
      i = i + 1
    }
    isCorrect = isMatched
  }
  return isCorrect
}

function prependProtocol (url) {
  if (url.includes('https://') || url.includes('http://')) return url
  return `https://${url}`
}

function makeRequestWithCustomParams(url, params) {
  const requestInfo = makeRequest(url)
  requestInfo.params = Object.assign({}, requestInfo.params, params)
  return requestInfo
}

function makeRequest (url) {
  return {
    url: prependProtocol(url),
    method: 'get',
    responseType: 'json',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json; charset=utf-8'
    },
    params: {
      apikey: 'E5F3E0D30947AA5440556471321BB6D9',
      device: 'mobile',
      partner: 'pooq',
      pooqzone: 'none',
      region: 'kor',
      drm: 'dm',
      targetage: 'all',
      credential: 'none'
    },
    paramsSerializer: (params) => {
      return Object.keys(params).map(key => key + '=' + params[key]).join('&')
    }
  }
}

export const isListUrl = (completedUrl) => {
  return completedUrl.indexOf('https://m.wavve.com/list') > -1;
}

export const getDeeplinkUrl = (uiCode) => {
  const url = `https://apis.wavve.com/cf/deeplink/${uiCode}`
  return axios(makeRequest(url))
}

export const getDeepLinkUrlWithDeviceType = ({uiCode, deviceType}) => {
  const url = `https://apis.wavve.com/cf/deeplink/${uiCode}`
  return axios(makeRequestWithCustomParams(url, {device : deviceType}))
}
